import _axios from "axios";

const axios = _axios.create();
import projectConfig from "@projectConfig";

const translationServiceHost = process.env.REACT_APP_TRANSLATIONS_SERVICE;
const scope = (projectConfig.scope ?? "").toLowerCase();

export const getTranslation = async (language) => {
   return axios({
      method: "get",
      url: `${translationServiceHost}/translations`,
      headers: {
         Accept: "*/*",
      },
      params: scope.trim().length === 0 ? { langKey: language } : { langKey: language, scope },
   });
};

export const postNewTranslation = async (data) => {
   return axios({
      method: "post",
      url: `${translationServiceHost}/translations`,
      headers: {
         Accept: "*/*",
      },
      data,
   });
};

export const getAllTranslations = async () => {
   return axios({
      method: "get",
      url: `${translationServiceHost}/translations/all`,
      headers: {
         Accept: "*/*",
      },
   });
};

export const editTranslations = async (data) => {
   return axios({
      method: "put",
      url: `${translationServiceHost}/translations`,
      headers: {
         Accept: "*/*",
      },
      data,
   });
};

export const getAllLanguages = async () => {
   return axios({
      method: "get",
      url: `${translationServiceHost}/language/all`,
      headers: {
         Accept: "*/*",
      },
   });
};

export const deleteTranslations = async (langKeys) => {
   return axios({
      method: "delete",
      url: `${translationServiceHost}/translations/multiple`,
      headers: {
         Accept: "*/*",
      },
      data: langKeys,
   });
};

export const deleteTranslation = async (langKey, scope) => {
   return axios({
      method: "delete",
      url: `${translationServiceHost}/translations`,
      headers: {
         Accept: "*/*",
      },
      params: { langKey, scope },
   });
};
